import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import './index.scss';

class SignInCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    const {
      endTime,
      currentTime,
      isContinueTask,
      continueTaskDays = 0,
      completed = 0,
      totalStep = 0,
      totalTaskDays = 0 } = this.props.signTask;
    const days = moment(endTime * 1000).diff(moment(currentTime * 1000), 'day') + 1;

    // let text = '';
    // if (days === 0) {
    //   text = '活动今天结束，记得提现哦';
    // } else {
    //   if (this.props.isNewUser) {
    //     text = `新用户专享，活动${days}天后结束`;
    //   } else {
    //     text = `活动${days}天后结束，断签后重新开始哦`;
    //   }
    // }
    const leftDay = isContinueTask ? totalTaskDays - continueTaskDays : totalStep - completed;
    const text = leftDay <= 0 ? '任务完成, 恭喜获得腾讯视频VIP卡' : `继续签到${leftDay}天领取VIP卡，断签不可领取`;

    return (
			<div className="signInCarousel">
				<div className="notice">
					{/* <span className="icon"></span> */}
					{text}
				</div>
			</div>
    );
  }
}

const mapStateToProps = (state) => {
  const { isNewUser, signTask } = state;
  return {
    isNewUser,
    signTask,
  };
};

export default connect(mapStateToProps)(SignInCarousel);
